import { normalizeLocationCoordinates } from '../use-cases'
import { getConfig } from '@/tools/config'
import { fetcher } from '@/tools/fetcher/client'
import type { AddressCoordinates, GoogleAddress } from '@/user/address-book/entities'
import { GoogleAddressSchema } from '@/user/address-book/entities'

export const getGoogleAddressByCoordinates = async (
  coordinates: AddressCoordinates,
  isAuthUser: boolean = false
): Promise<GoogleAddress> => {
  const { apiUrl } = getConfig()
  const { longitude, latitude } = normalizeLocationCoordinates(coordinates)

  const response = await fetcher.get<GoogleAddress>(
    `${apiUrl}/v3/addresslookup/${isAuthUser ? '' : 'pub/'}coordinates?latitude=${latitude}&longitude=${longitude}`
  )
  return GoogleAddressSchema.parse(response.data)
}
